import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initSentry, Sentry } from '@/shared/observability';
import { resolveRoute } from '@/routes/routes';
import './styles/globals.css';

initSentry();

function ErrorFallback() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
        textAlign: 'center',
        fontFamily: 'system-ui, sans-serif',
        color: '#27231C',
        background: '#F7F5F2',
      }}
    >
      <h1 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>Algo salió mal</h1>
      <p style={{ opacity: 0.7, marginBottom: '1.5rem' }}>
        Hubo un error inesperado. Recargá la página para volver a intentar.
      </p>
      <button
        onClick={() => window.location.reload()}
        style={{
          padding: '0.75rem 1.5rem',
          borderRadius: 9999,
          border: 'none',
          background: '#2E6CC8',
          color: '#fff',
          fontSize: '1rem',
          cursor: 'pointer',
        }}
      >
        Recargar
      </button>
    </div>
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      {resolveRoute(window.location.pathname)}
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
